import types from './types';

const {
  LOOKUP_FOLIO, LOOKUP_FOLIO_SUCCESS, LOOKUP_FOLIO_FAIL,
  SUBMIT_CHECKIN, SUBMIT_CHECKIN_SUCCESS, SUBMIT_CHECKIN_FAIL,
} = types;

export const initialState = {
  looking: false,
  looked: false,
  booking: null,
  error: null,
  submitting: false,
  submitted: false,
  submitError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOOKUP_FOLIO:
      return { ...state, looking: true, looked: false, booking: null, error: null };
    case LOOKUP_FOLIO_SUCCESS:
      return { ...state, looking: false, looked: true, booking: action.result, error: null };
    case LOOKUP_FOLIO_FAIL:
      return { ...state, looking: false, looked: false, booking: null, error: action.error };
    case SUBMIT_CHECKIN:
      return { ...state, submitting: true, submitted: false, submitError: null };
    case SUBMIT_CHECKIN_SUCCESS:
      return { ...state, submitting: false, submitted: true, submitError: null };
    case SUBMIT_CHECKIN_FAIL:
      return { ...state, submitting: false, submitted: false, submitError: action.error };
    default:
      return state;
  }
}
